 import React, { useEffect, useState } from "react"; 
import { getPrincipalMessage } from "../Service/Api"; 
import { Link } from "react-router-dom";
const Testimonials = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData = await getPrincipalMessage();
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const emptyData = [
    {
      category: "Principal",
      title: "Principal Message",
      name: "Name",
      designation: (
        <>
          principal 
           
        </>
      ),
      message: (
        <>
        Lorem ipsum dolor sit amet consectetur. Fames sapien consectetur turpis massa ultricies turpis arcu cursus. Tristique praesent semper vivamus eu ut odio. Turpis habitant accumsan posuere lorem orci dis augue. Ipsum commodo ac urna nulla mattis erat sit. 
        </>
      ),

      image:
        "https://webapi.entab.info/api/image/SHCSKWB/public/Images/dummy.jpg",
      link: "/",
    },
  ];  
  return (
    <>
           {data && data.length > 0
        ? data.map((item, index) => (
          <div className="message-container">
          <div className="messageimg">
            <div className="testimonialimg">
              <img
                src={`https://webapi.entab.info/api/image/${item.attachments}`}
                alt="SHCSKWB"
                className="img-fluid"
              />
            </div> 
            <div className="messageboximg">
              <p>
                {item.name} <span> {item.category} </span> 
              </p>
            </div>
          </div>
          <div className="messagebox">
          <div className='title'> 
                <h2>FROM THE DESK OF</h2>
              </div>
            <div className="messagedesc">
              <div className="maintitle">
                <h3>{item.category}'s message </h3>
              </div>
              <div className="msginfo">
                 <div dangerouslySetInnerHTML={{ __html: item.message }} />
             </div>
            </div>
            <div className="mainbtn button">
              <Link to="/PrincipalMessage"> Read More</Link>
            </div> 
          </div>  
        </div>
          ))
        : emptyData.map((data) => (
          <div className="message-container">
          <div className="messageimg">
            <div className="testimonialimg">
              <img
                src={data.image}
                alt="SHCSKWB"
                className="img-fluid"
              />
            </div> 
            <div className="messageboximg">
              <p>
                 Fr. Gregory Monteiro <span> Principal </span> 
              </p>
            </div>
          </div>
          <div className="messagebox">
          <div className='title'> 
                <h2>FROM THE DESK OF</h2>
              </div>
            <div className="messagedesc">
              <div className="maintitle">
                <h3>{data.category}'s message </h3>
              </div>
              <div className="msginfo">
              <p><i>On the Launch of Our New School Website</i></p>
              <p><b>Dear Parents, Students, Teachers, and Staff,
              Greetings to each one of you!</b></p>
                   <p>It is with great joy and pride that I announce the launch of our new official website for Sacred Heart School, Kharagpur. This platform marks a new beginning in how we connect, share, and grow together as a school community. It will serve as a dynamic source of information, providing timely updates on academic activities, events, achievements, </p>
             </div>
            </div>
            <div className="mainbtn button">
              <Link to="/PrincipalMessage"> Read More</Link>
            </div> 
          </div>  
        </div>
          ))}  
          
    </>
  );
};

export default Testimonials;
